import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
/**
 * Scrolls the window to the top whenever the route's pathname changes.
 * Must live inside a <BrowserRouter>.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' as ScrollBehavior
    });
  }, [pathname]);
  return null;
}